import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { LanguageSwitcher } from '../../components/language/LanguageSwitcher'
import { useI18n } from '../i18n/useI18n'
import './native-public.css'

export function NativePublicLayout({children,back=false}:{children:ReactNode;back?:boolean}) {
  const { t }=useI18n()
  return <main className="native-public"><header>{back?<Link to="/welcome" className="native-back" aria-label={t('Back to welcome')}>‹ <span>{t('Back')}</span></Link>:<span/>}<Link to="/welcome" className="native-brand"><span className="brand-mark">PR</span><strong>PropertyReady</strong></Link><LanguageSwitcher/></header>{children}</main>
}

export function NativeStepList({items}:{items:Array<[string,string]>}) { const{t}=useI18n(); return <ol className="native-step-list">{items.map(([title,body],index)=><li key={title}><span>{index+1}</span><div><strong>{t(title)}</strong><p>{t(body)}</p></div></li>)}</ol> }
